<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("neighbor module settings") }}
      </h1>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("account module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_every_neighbor_has_account"
            name="chk_every_neighbor_has_account"
            v-model="meta.every_neighbor_has_account"
          />
          <label for="chk_every_neighbor_has_account">{{
            $t("every neighbor has an account")
          }}</label>
          <div
            class="button is-rounded is-primary is-small"
            @click="check_neighbor_account_existance"
          >
            <span class="icon"><i class="fa fa-check"></i></span>
            <span>{{ $t("check") }}</span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('account type')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/account/type/catalog"
            name_field="name"
            value_field="type_id"
            @selected="account_type_changed"
            ref="account_type_dropdown"
          />
        </div>
      </div>
    </div>
    <!-- <div class="columns">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('movement type to apply on promotion buying')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/account/movement_type/catalog"
            name_field="name"
            value_field="movement_type_id"
            @selected="movement_type_changed"
            ref="movement_type_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('movement type to apply on payment registered')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/account/movement_type/catalog"
            name_field="name"
            value_field="movement_type_id"
            @selected="payment_movement_type_changed"
            ref="payment_movement_type_dropdown"
          />
        </div>
      </div>
    </div> -->

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("drive module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_drive_neighbor"
            name="chk_integrate_drive"
            v-model="meta.integrate_drive"
          />
          <label for="chk_integrate_drive_neighbor">{{
            $t("integrate")
          }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_changed"
            ref="drive_dropdown"
          />
        </div>
      </div>
      <!-- <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive for qr codes')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_qr_changed"
            ref="drive_qr_dropdown"
          />
        </div>
      </div> -->
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("outbox module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_outbox"
            name="chk_integrate_outbox"
            v-model="meta.integrate_outbox"
          />
          <label for="chk_integrate_outbox">{{ $t("integrate") }}</label>
        </div>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_attach_rules_to_mail"
            name="chk_attach_rules_to_mail"
            v-model="meta.attach_rules_to_rules_mail"
          />
          <label for="chk_attach_rules_to_mail">{{
            $t("attach rules to mail")
          }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('template for rules mail')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/outbox/template/catalog"
            name_field="name"
            value_field="template_id"
            @selected="mail_template_changed"
            ref="mail_template_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("rules pdf") }}</label>
          <generic-uploader
            ref="generic_uploader"
            :idle_label="$t('drop pdf here')"
            endpoint_url="/gym_member/rules"
            @error="error_uploading"
            @success="success_uploading"
            :allow_multiple="false"
          />
        </div>
        <div class="tags has-addons" v-if="meta && meta.rules_pdf">
          <span class="tag is-primary">
            <span class="icon"><i class="fa fa-file-text"></i></span>
          </span>
          <span class="tag">
            <span>{{ meta.rules_pdf.file.name }}</span>
          </span>
        </div>
      </div>
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  post,
  error_message,
  success_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";

export default {
  name: "Gym_memberSettings",
  components: { GenericDropdown, GenericUploader },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    save() {
      let v = this;
      let data = v.meta;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {
          console.log("configuration saved", response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
    mail_template_changed(value) {
      this.meta.mail_template_id = value.template_id;
    },
    account_type_changed(value) {
      this.meta.account_type_id = value.type_id;
    },
    movement_type_changed(value) {
      this.meta.movement_type_id = value.movement_type_id;
    },
    payment_movement_type_changed(value) {
      this.meta.payment_movement_type_id = value.movement_type_id;
    },
    drive_changed(value) {
      this.meta.drive_id = value.drive_id;
    },
    error_uploading(error) {
      console.error("error_uploading", error);
      // let v = this;
      // v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      let server_response = JSON.parse(response.serverId);
      v.meta.rules_pdf = server_response;
      // v.$refs.generic_uploader.clear();
      // v.init();
    },
    check_neighbor_account_existance() {
      let v = this;
      post("/neighbor/account-existance")
        .then((response) => {
          success_message(v.$t("every neighbor has an account"));
        })
        .catch((error) => {
          error_message(error);
        });
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) {
          v.meta = conf;
          if (conf.account_type_id) {
            v.$refs.account_type_dropdown.set_value(conf.account_type_id);
          }

          if (conf.drive_id) {
            v.$refs.drive_dropdown.set_value(conf.drive_id);
          }
          if (conf.mail_template_id) {
            v.$refs.mail_template_dropdown.set_value(conf.mail_template_id);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
